import { types } from 'mobx-state-tree';
import { Point } from './GeoJSON';
export const BasicOrganization = types.model({
  id: types.identifier,
  name: types.string,
  phone: types.maybeNull(types.string),
  slug: types.string,
  location: types.maybeNull(types.late(() => Point))
});